import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { Constants } from 'app/shared/config/constants';
import { isIframeModeEnabled } from 'app/shared/lib';
import { BusinessUnitsService } from 'app/shared/services/business-units.service';
import {
  ClientService,
  IncidentService,
  UserService,
} from 'app/shared/services';

@Injectable ( {
  providedIn: 'root',
} )
export class IncidentPropertiesIframeClientGuard {

  constructor (
    private incidentService: IncidentService,
    private businessUnitsService: BusinessUnitsService,
    private clientService: ClientService,
    private userService: UserService,
  ) {
  }

  async canActivate ( route: ActivatedRouteSnapshot, _state: RouterStateSnapshot ): Promise<boolean> {
    const claimNumber = route.queryParams.claimNumber;

    if ( !isIframeModeEnabled ( route.queryParams ) || !claimNumber ) {
      return true;
    }

    const currentClientNumber = this.userService.currentClient?.clientNumber;

    if ( !currentClientNumber ) {
      return true;
    }

    try {
      const properties = await this.incidentService.getIncidentMetaDataByClaimNumber ( currentClientNumber, claimNumber ).toPromise ();
      const reportingLocationId = properties?.reportingLocationId;

      if ( !reportingLocationId ) {
        return true;
      }

      const businessUnit = await this.businessUnitsService.getBUDetails ( reportingLocationId ).toPromise ();
      const clientNumber = businessUnit?.gbClientNumber;

      if ( !clientNumber ) {
        return true;
      }

      if ( !this.userService.userClients.find ( client => client.clientNumber === clientNumber ) ) {
        const clients = await this.clientService.searchClients ( clientNumber ).toPromise ();
        if ( clients?.[ 0 ] ) {
          await this.userService.addTempClient ( clients[ 0 ] );
        }
      }

      if ( this.userService.userClients.find ( client => client.clientNumber === clientNumber ) ) {
        this.userService.enableClientChange ();
        this.userService.currentClientNumber = clientNumber;
        await this.clientService.getBUSettings ();
        localStorage.setItem ( Constants.localStorageKeys.reporterClientSelected, '1' );
      }
    } catch ( error ) {
      // Let the resolver/component handle the normal iframe not-found state.
    }

    return true;
  }
}

